import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import type { InternalLink } from "~/utils/seo/internalLinks";

import styles from "./index.module.scss";

/**
 * Блок перелинковки под контентом любой страницы. Ссылки заводятся в панели
 * («SEO → Перелинковка»), подходящие под адрес выбираются на сервере в
 * pagesWrapper — здесь только вывод.
 */
export default function InternalLinks() {
  const { internalLinks } = useSelector((state: any) => state.meta);
  const router = useRouter();

  // В работах портфолио ссылки выводятся последним предложением текста,
  // блок под страницей их бы продублировал
  if (!internalLinks?.length || router.asPath.startsWith("/nashe-portfolio")) {
    return null;
  }

  return (
    <div className={styles.InternalLinks}>
      <div className="container">
        <div className={styles.Title}>Смотрите также</div>
        <ul className={styles.Items}>
          {internalLinks.map((link: InternalLink) => (
            <li key={`${link.url}:${link.anchor}`}>
              <Link href={link.url}>
                <a className={styles.Item} href={link.url}>
                  {link.anchor}
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
